import { createFileRoute } from '@tanstack/react-router';

import { VulglanceIndexPage } from '@/features/vulglance/routes/IndexPage';

export const Route = createFileRoute('/vulglance/')({
  component: VulglanceIndexPage,
});
